import React from 'react';
import { ArrowRight, BarChart3, Package, ListChecks, TrendingUp } from 'lucide-react';

const Home = () => {
  const features = [
    {
      icon: <ListChecks size={32} />,
      title: 'Order Management',
      description: 'Streamline your order processing with automated workflows, bulk actions, and real-time status tracking across all your TikTok Shop orders.',
    },
    {
      icon: <Package size={32} />,
      title: 'Product Sync',
      description: 'Effortlessly synchronize your product catalog across multiple platforms. Update pricing, descriptions, and images in one place.',
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Inventory Tracking',
      description: 'Never oversell again. Get real-time inventory updates, low stock alerts, and automated reordering suggestions.',
    },
    {
      icon: <BarChart3 size={32} />,
      title: 'Data Analytics',
      description: 'Make data-driven decisions with comprehensive analytics, sales insights, and performance metrics tailored for TikTok Shop sellers.',
    },
  ];

  return (
    <div className="page-content">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-bg"></div>
        <div className="hero-blob hero-blob-1"></div>
        <div className="hero-blob hero-blob-2"></div>
        
        <div className="container">
          <div className="hero-content">
            <div className="badge">Trusted by 1,000+ TikTok Shop Sellers</div>
            <h1 className="hero-title">
              Supercharge Your<br />TikTok Shop Business
            </h1>
            <p className="hero-subtitle">
              We provide tools for TikTok Shop sellers to manage products, orders, and data efficiently.
            </p>
            <div className="hero-buttons">
              <a href="#/contact" className="btn btn-primary">
                Get Started <ArrowRight size={20} />
              </a>
              <a href="#/features" className="btn btn-secondary">
                Learn More
              </a>
            </div>
          </div>

          <div className="feature-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card" style={{animationDelay: `${index * 0.1}s`}}>
                <div className="feature-icon">
                  {feature.icon}
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">10K+</div>
              <div className="stat-label">Orders Processed Daily</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">99.9%</div>
              <div className="stat-label">Uptime Guarantee</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Customer Support</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container-small">
          <h2 className="cta-title">Ready to Scale Your TikTok Shop?</h2>
          <p className="cta-subtitle">
            Join thousands of sellers who trust our platform to grow their business.
          </p>
          <a href="#/contact" className="btn btn-primary btn-large">
            Start Free Trial
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;
